import { config, getApiBaseUrl } from '../../config/app-config';
import { showSuccessNotification, showErrorNotification } from '../../utils/notifications';
import { apiPost } from '../../utils/api';

export function initContactForm() {
    console.log('Initializing contact form...');

    // ИСПРАВЛЕНИЕ: Используем специфичные селекторы, исключающие форму вакансий
    const input = document.querySelector(".contact-form:not(#vacancy-apply-form .contact-form) #phone");
    const label = document.querySelector('.contact-form:not(#vacancy-apply-form .contact-form) label[for="phone"]');
    const form = document.querySelector('.contact-form:not(#vacancy-apply-form .contact-form)');
    const submitBtn = document.querySelector('.contact-form:not(#vacancy-apply-form .contact-form) .submit-btn');
    let iti;

    if (!input || !form) {
        console.log('Contact form elements not found on this page');
        return;
    }

    // Функция создания элемента ошибки для любого поля
    function createErrorElement(inputElement) {
        if (!inputElement) return null;

        const errorElement = document.createElement('div');
        errorElement.className = 'field-error-message';

        // Шукаємо .input-wrapper (а не .input-inner або .iti) — помилка йде ПІСЛЯ .input-inner
        const wrapper = inputElement.closest('.input-wrapper');
        if (wrapper) {
            wrapper.classList.add('field-wrapper');
            wrapper.appendChild(errorElement);
        }

        return errorElement;
    }

    // Создаем элементы ошибок для всех полей с обновленными селекторами
    const phoneErrorMessage = createErrorElement(input);
    const nameErrorMessage = createErrorElement(form.querySelector('#name'));
    const clinicErrorMessage = createErrorElement(form.querySelector('#clinic'));
    const messageErrorMessage = createErrorElement(form.querySelector('#message'));

    // Для чекбокса только рамка, без текста ошибки
    const checkboxInput = form.querySelector('.checkbox-input');

    // Универсальные функции для показа/скрытия ошибок
    function showFieldError(inputElement, errorElement, message) {
        if (!inputElement || !errorElement) return;
        inputElement.classList.add('field-error');
        errorElement.textContent = message;
        errorElement.classList.add('show');
    }

    function clearFieldError(inputElement, errorElement) {
        if (!inputElement || !errorElement) return;
        inputElement.classList.remove('field-error');
        errorElement.classList.remove('show');
    }

    function showAgreementError() {
        if (checkboxInput) {
            checkboxInput.classList.add('field-error');
        }
    }

    function clearAgreementError() {
        if (checkboxInput) {
            checkboxInput.classList.remove('field-error');
        }
    }

    // Функции для управления лейблом телефона
    function hidePhoneLabel() {
        if (label) {
            label.style.opacity = '0';
            label.style.visibility = 'hidden';
        }
    }

    function showPhoneLabel() {
        if (label && !input.value.trim()) {
            label.style.opacity = '0.6';
            label.style.visibility = 'visible';
        }
    }

    // Инициализация intlTelInput
    if (input && label && window.intlTelInput) {
        iti = window.intlTelInput(input, {
            utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.js",
            initialCountry: "ua",
            separateDialCode: true,
            autoPlaceholder: "off",
            preferredCountries: ["ua", "pl", "us", "gb"],
            formatOnDisplay: true,
            nationalMode: false,
            validationNumberTypes: ["MOBILE", "FIXED_LINE"],
            dropdownContainer: document.querySelector('body')
        });

        console.log('intlTelInput initialized');
    } else {
        console.warn('intlTelInput library not found or input elements missing');
    }

    // Функция валидации номера телефона
    function validatePhone() {
        const phoneNumber = input.value.trim();

        if (!phoneNumber) {
            showFieldError(input, phoneErrorMessage, 'Поле "Телефон" обов\'язкове для заповнення');
            return false;
        }

        if (iti && iti.isValidNumber()) {
            clearFieldError(input, phoneErrorMessage);
            return true;
        } else {
            showFieldError(input, phoneErrorMessage, 'Невірний номер телефону');
            return false;
        }
    }

    // Функции валидации других полей
    function validateName() {
        const nameField = form.querySelector('#name');
        if (!nameField) return true;

        const name = nameField.value.trim();

        if (!name) {
            showFieldError(nameField, nameErrorMessage, 'Поле "Ім\'я" обов\'язкове для заповнення');
            return false;
        } else {
            clearFieldError(nameField, nameErrorMessage);
            return true;
        }
    }

    function validateClinic() {
        const clinicField = form.querySelector('#clinic');
        if (!clinicField) return true;

        const clinic = clinicField.value.trim();

        if (!clinic) {
            showFieldError(clinicField, clinicErrorMessage, 'Поле "Назва вашої клініки" обов\'язкове для заповнення');
            return false;
        } else {
            clearFieldError(clinicField, clinicErrorMessage);
            return true;
        }
    }

    function validateMessage() {
        const messageField = form.querySelector('#message');
        if (!messageField) return true;

        const message = messageField.value.trim();

        if (!message) {
            showFieldError(messageField, messageErrorMessage, 'Поле "Повідомлення" обов\'язкове для заповнення');
            return false;
        } else {
            clearFieldError(messageField, messageErrorMessage);
            return true;
        }
    }

    function validateAgreement() {
        if (!checkboxInput) return true;

        if (!checkboxInput.checked) {
            showAgreementError();
            return false;
        } else {
            clearAgreementError();
            return true;
        }
    }

    // Настройка обработчиков событий
    function setupEventListeners() {
        // Обработчики событий для поля телефона
        if (input && label) {
            input.addEventListener('focus', function() {
                hidePhoneLabel();
            });

            input.addEventListener('blur', function() {
                if (!this.value.trim()) {
                    showPhoneLabel();
                }
                validatePhone();
            });

            input.addEventListener('input', function() {
                if (this.value.trim()) {
                    hidePhoneLabel();
                } else {
                    showPhoneLabel();
                }
                clearFieldError(input, phoneErrorMessage);
            });

            input.addEventListener('change', function() {
                if (this.value.trim()) {
                    hidePhoneLabel();
                } else {
                    showPhoneLabel();
                }
                clearFieldError(input, phoneErrorMessage);
            });

            input.addEventListener('keyup', function() {
                if (this.value.trim()) {
                    hidePhoneLabel();
                } else {
                    showPhoneLabel();
                }
                clearFieldError(input, phoneErrorMessage);
            });

            input.addEventListener('countrychange', function() {
                clearFieldError(input, phoneErrorMessage);
            });

            // Начальное состояние
            if (input.value.trim()) {
                hidePhoneLabel();
            } else {
                showPhoneLabel();
            }

            // Клик по лейблу фокусирует input
            label.addEventListener('click', function() {
                input.focus();
            });
        }

        // Обработчики для других полей
        const nameField = form.querySelector('#name');
        if (nameField) {
            nameField.addEventListener('blur', validateName);
            nameField.addEventListener('input', function() {
                clearFieldError(this, nameErrorMessage);
            });
        }

        const clinicField = form.querySelector('#clinic');
        if (clinicField) {
            clinicField.addEventListener('blur', validateClinic);
            clinicField.addEventListener('input', function() {
                clearFieldError(this, clinicErrorMessage);
            });
        }

        const messageField = form.querySelector('#message');
        if (messageField) {
            messageField.addEventListener('blur', validateMessage);
            messageField.addEventListener('input', function() {
                clearFieldError(this, messageErrorMessage);
            });
        }

        if (checkboxInput) {
            checkboxInput.addEventListener('change', function() {
                if (this.checked) {
                    clearAgreementError();
                }
            });
        }
    }

    // Функция отправки формы на сервер
    async function submitFormToServer(formData) {
        try {
            console.log('Отправка данных на сервер...', formData);

            // Показываем индикатор загрузки
            if (submitBtn) {
                const originalText = submitBtn.textContent;
                submitBtn.textContent = 'Відправка...';
                submitBtn.disabled = true;
            }

            const response = await apiPost(config.api.paths.contactForm, formData, {
                auth: false // Форма не требует авторизации
            });

            console.log('Ответ сервера:', response);

            // Показываем уведомление об успехе
            showSuccessNotification('Ваше повідомлення успішно відправлено! Ми зв\'яжемося з вами найближчим часом.');

            // Очищаем форму
            form.reset();
            if (iti) {
                iti.setNumber('');
            }
            // Показываем лейбл после очистки
            showPhoneLabel();

            // Восстанавливаем кнопку
            if (submitBtn) {
                submitBtn.textContent = 'Відправити';
                submitBtn.disabled = false;
            }

            return response;

        } catch (error) {
            console.error('Ошибка при отправке формы:', error);

            // Показываем уведомление об ошибке
            let errorMessage = 'Помилка при відправці повідомлення. Спробуйте ще раз.';

            if (error.response && error.response.data && error.response.data.detail) {
                errorMessage = error.response.data.detail;
            }

            showErrorNotification(errorMessage);

            // Восстанавливаем кнопку
            if (submitBtn) {
                submitBtn.textContent = 'Відправити';
                submitBtn.disabled = false;
            }

            throw error;
        }
    }

    // Обработка сабмита формы
    if (form) {
        form.addEventListener('submit', async function(e) {
            e.preventDefault();

            console.log('=== ОТПРАВКА ФОРМЫ ===');

            // Валидация всех полей
            const isNameValid = validateName();
            const isPhoneValid = validatePhone();
            const isClinicValid = validateClinic();
            const isMessageValid = validateMessage();
            const isAgreementValid = validateAgreement();

            const isFormValid = isNameValid && isPhoneValid && isClinicValid && isMessageValid && isAgreementValid;

            console.log('Валидация:', isFormValid ? 'ПРОЙДЕНА' : 'НЕ ПРОЙДЕНА');

            if (!isFormValid) {
                console.log('Есть ошибки валидации. Проверьте поля с красной рамкой.');
                showErrorNotification('Будь ласка, виправте помилки у формі');
                return;
            }

            // Собираем данные формы
            const formData = {
                name: form.querySelector('#name')?.value.trim() || '',
                phone: input.value.trim(),
                clinic: form.querySelector('#clinic')?.value.trim() || '',
                message: form.querySelector('#message')?.value.trim() || '',
                agreement: checkboxInput?.checked || false
            };

            console.log('Данные формы:', formData);

            // Получаем дополнительную информацию о телефоне
            if (iti) {
                const phoneInfo = {
                    number: iti.getNumber(),
                    country: iti.getSelectedCountryData(),
                    isValid: iti.isValidNumber(),
                    type: iti.getNumberType()
                };
                console.log('Информация о телефоне:', phoneInfo);

                // Добавляем полный номер в международном формате
                formData.phone = iti.getNumber();
                formData.phone_country = iti.getSelectedCountryData().iso2;
            }

            try {
                await submitFormToServer(formData);
            } catch (error) {
                // Ошибка уже обработана в submitFormToServer
            }
        });
    }

    // Настраиваем обработчики событий
    setupEventListeners();

    console.log('Contact form initialized successfully');

    // Делаем iti доступным глобально для отладки
    if (iti) {
        window.iti = iti;
    }
}

export function hasContactForm() {
    // Проверяем что есть контактная форма, но НЕ форма вакансий И НЕ форма курса
    const contactForm = document.querySelector('.contact-form');
    const vacancyForm = document.querySelector('#vacancy-apply-form .contact-form');
    const courseForm = document.querySelector('#course-registration-modal .contact-form');

    return contactForm !== null && contactForm !== vacancyForm && contactForm !== courseForm;
}